import {
  SET_WEEDS,
  ADD_CHECKED_WEED,
  REMOVE_CHECKED_WEED,
  CLEAR_WEEDS
} from "./types";

export const initialState = {
  selectedWeedIds: [],
  weeds: []
};

export const weeds = (state = initialState, action) => {
  switch (action.type) {
    case SET_WEEDS:
      return {
        ...state,
        weeds: action.payload,
        selectedWeedIds: []
      };
    case ADD_CHECKED_WEED:
      return {
        ...state,
        selectedWeedIds: state.selectedWeedIds.concat(action.payload)
      };
    case REMOVE_CHECKED_WEED:
      return {
        ...state,
        selectedWeedIds: [
          ...state.selectedWeedIds.slice(0, action.payload),
          ...state.selectedWeedIds.slice(action.payload + 1)
        ]
      };
    case CLEAR_WEEDS: {
      return initialState;
    }
    default:
      return state;
  }
};

export default weeds;
